import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import type { NihaoBridgeContent } from "../content/types";

interface CTASectionProps {
  content: NihaoBridgeContent["cta"];
}

export default function CTASection({ content }: CTASectionProps) {
  return (
    <section className="w-full py-20 px-[5%] bg-white relative" id="cta">
      <div className="max-w-3xl mx-auto text-center text-slate-900">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-3xl lg:text-4xl font-bold mb-6"
        >
          {content.title}
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          viewport={{ once: true }}
          className="text-lg mb-10 text-slate-600 leading-relaxed"
        >
          {content.description}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="flex flex-wrap gap-4 justify-center"
        >
          <motion.a
            whileHover={{ scale: 1.05, y: -2 }}
            whileTap={{ scale: 0.98 }}
            href="#contact"
            className="inline-flex items-center gap-2 bg-cyan-500 text-white px-8 py-4 text-lg font-semibold rounded-xl shadow-lg hover:shadow-xl hover:bg-cyan-600 transition-all duration-300"
          >
            <Mail className="w-5 h-5" />
            {content.contactButton}
          </motion.a>
        </motion.div>
      </div>

      {/* Animated horizontal line at bottom */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-400/20 to-transparent" />
    </section>
  );
}
